import Preview from "./alignment/linearPreview";
import AlignmentContainer from "./alignment/alignment";
import Overview from "./alignment/overview";
import Sidebar from "./alignment/sidebar";
import Mediator from "./mixins/mediator";
import {fetchData} from './editor/utils';

document.addEventListener("DOMContentLoaded", async function () {
    const container = document.getElementById("alignment")
    if (container) {
        await fetchData(container.dataset.url).then(data => {
            const mediator = new Mediator();
            const alignment = new AlignmentContainer({
                "annotation_colors": JSON.parse(document.getElementById("colors").innerHTML),
            }, mediator);

            new Preview({}, mediator);
            new Overview({}, mediator);
            new Sidebar({
                "annotation_colors": JSON.parse(document.getElementById("colors").innerHTML),
            }, mediator);

            alignment.setData(data);
        })

        if (container.dataset.valid === 'false') {
            let invalidAlignmentModal = new Modal('#invalidAlignmentModal');
            invalidAlignmentModal.show();
        }
    }
});
